// extracted by mini-css-extract-plugin
module.exports = {"category-list-container":"CategorySelectionDropdown_category-list-container__333fY","category-list":"CategorySelectionDropdown_category-list__yv5hn"};